import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=72f488e2&"
import script from "./BaseNav.vue?vue&type=script&lang=js&"
export * from "./BaseNav.vue?vue&type=script&lang=js&"
import style0 from "./BaseNav.vue?vue&type=style&index=0&id=72f488e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports